import { useEffect, useRef, useState } from "react";
import { differenceInMilliseconds } from "date-fns";

/**
 * `useRunningTime` is a hook that returns the time elapsed since the start time. It refreshes every second.
 * @param startTime - The start time of the timer
 * @returns
 * - `runningTime` - The running time in milliseconds
 * - `endTimer` - A function that clears the timer
 */
export const useRunningTime = (startTime: Date) => {
  const [runningTime, setRunningTime] = useState(() =>
    differenceInMilliseconds(Date.now(), startTime),
  );
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    timerRef.current = setInterval(() => {
      const newRunningTime = differenceInMilliseconds(Date.now(), startTime);
      setRunningTime(newRunningTime > 0 ? newRunningTime : 0);
    }, 1000);
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, [startTime]);

  const endTimer = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  };

  return { runningTime, endTimer };
};
